import { render, staticRenderFns } from "./YHeader.vue?vue&type=template&id=a11964da&scoped=true&"
import script from "./YHeader.vue?vue&type=script&lang=js&"
export * from "./YHeader.vue?vue&type=script&lang=js&"
import style0 from "./YHeader.vue?vue&type=style&index=0&id=a11964da&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a11964da",
  null
  
)

export default component.exports